// What a screen inside the shell may ask of it: a slot at the end of the
// phone header for its own actions, and a temporary rail while it needs the
// width (Chat with Riwayat open below 1280). Neither is remembered.
import { createContext, useContext, useEffect } from "react";

export interface ShellApi {
  /** The element at the end of the phone header, or null before it mounts. */
  headerSlot: HTMLElement | null;
  /**
   * The screen fills the header slot; the header then shows its title on one
   * line. With heading true the title is the screen's one h1 (the phone
   * header names the open conversation); otherwise it is plain text.
   */
  setHeaderTitle: (title: string | null, heading?: boolean) => void;
  /** Collapse the drawer to the rail while true, without saving the choice. */
  setForceRail: (on: boolean) => void;
}

export const ShellContext = createContext<ShellApi | null>(null);

export function useShell(): ShellApi | null {
  return useContext(ShellContext);
}

/** Holds the drawer on the rail while `on`, and releases it on unmount. */
export function useForceRail(on: boolean): void {
  const shell = useShell();
  const set = shell?.setForceRail;
  useEffect(() => {
    if (!set) return;
    set(on);
    return () => set(false);
  }, [on, set]);
}
